import iconHTML from '../../helpers/html/icon.js';
import iconNext from '@fnacdarty/fnac-icons/svg/icon_i_055_arrow_right_01.svg?svgref';
import iconPrev from '@fnacdarty/fnac-icons/svg/icon_i_057_arrow_left_01.svg?svgref';
import translation from '../../helpers/translation/translation.js';

/**
 * Template pour le carousel
 *
 * @param {object} params Paramètres du carousel
 * @param {boolean} params.arrows Afficher les flèches de navigation
 * @param {boolean} params.bullets Afficher les puces de navigation
 * @param {number} params.count Nombre d'éléments dans le carousel
 * @param {object} params.classNames Noms de classes CSS
 * @returns {string} Le HTML généré
 */
export const renderNCarousel = ({ arrows, bullets, count, classNames }) => {
  // Initialiser le HTML
  let html = ``;

  // Ajouter le bouton flèche précédente si nécessaire
  if (arrows) {
    html += `
      <button type="button"
        class="${classNames.ARROW} ${classNames.ARROW_PREV}"
        aria-label="${translation('component.carousel.a11y.button.prev')}">
          <div class="${classNames.ARROW_ICON}">
            ${iconHTML(iconPrev)}
          </div>
      </button>`;
  }

  // Ajouter le wrapper et les éléments
  html += `
      <div class="${classNames.WRAPPER}">
        <ul class="${classNames.SCROLLER}">`;

  // Générer les éléments de liste
  for (let i = 1; i <= count; i++) {
    html += `
          <li class="${classNames.ITEM}"></li>`;
  }

  html += `
        </ul>
      </div>`;

  // Ajouter le bouton flèche suivante si nécessaire
  if (arrows) {
    html += `
          <button type="button"
            class="${classNames.ARROW} ${classNames.ARROW_NEXT}"
            aria-label="${translation('component.carousel.a11y.button.next')}">
            <div class="${classNames.ARROW_ICON}">
              ${iconHTML(iconNext)}
            </div>
          </button>`;
  }

  // Ajouter les puces de navigation si nécessaire
  if (bullets) {
    html += `
          <nav class="${classNames.BULLETS}" role="navigation">`;
    for (let i = 1; i <= count; i++) {
      html += `
              <button type="button"></button>`;
    }
    html += `
          </nav>`;
  }

  return html;
};
